import { render, staticRenderFns } from "./BrandOrder.vue?vue&type=template&id=bf287a02&"
import script from "./BrandOrder.vue?vue&type=script&lang=js&"
export * from "./BrandOrder.vue?vue&type=script&lang=js&"
import style0 from "./BrandOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports